import ds from './DataSourceService'

const baseUrl = '/users/auth'

const authUser = credentials => {
  return ds.apiClientThinkHome.post(baseUrl, credentials)
}

export default {
  authUser
}
